"use client";

import { useEffect, useState } from "react";

/** True while the guest scrolls DOWN past `after` px; false again on any scroll up.
 *  Used by the phone section tabs and the sticky /search bar. `untilTop` keeps it true on
 *  scroll up too, until the guest is back within `after` px of the top. */
export function useHideOnScrollDown(after = 80, untilTop = false) {
  const [hidden, setHidden] = useState(false);
  useEffect(() => {
    let last = window.scrollY;
    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const y = window.scrollY;
        // Ignore iOS rubber-band jitter of a pixel or two.
        if (Math.abs(y - last) > 4) {
          setHidden(y > after && (untilTop || y > last));
          last = y;
        }
        ticking = false;
      });
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [after, untilTop]);
  return hidden;
}
